export default {
  getProduct: (state) => state.product,
  getProducts: (state) => state.products,
  getProductsMap(state) {
    let products = {};

    if (state.products)
      state.products.forEach((p) => {
        products[p.id] = { ...p };
      });

    return products;
  },
  getActiveProducts: (state) => state.products?.filter((p) => p.active),
  getProductsOnShowLanding: (state) => state.products?.filter((p) => p.show_on_landing),
  getProductUnitsOfMeasure: (state) => state.unitsOfMeasure,
};
